import { supabase } from '@/integrations/supabase/client';
import { UserProfile } from "@/types/models";

// Fetch users from the database by calling the secure Edge Function
export const getUsers = async (): Promise<UserProfile[]> => {
  const { data, error } = await supabase.functions.invoke('get-users-with-details');

  if (error) {
    console.error("Error invoking get-users-with-details function:", error);
    throw error;
  }

  if (data.error) {
    console.error("Error from get-users-with-details function:", data.error);
    throw new Error(data.error);
  }

  // The edge function returns the merged and sorted user list
  return data as UserProfile[];
};

// Create a new user by calling the Edge Function
export const createUser = async (userData: { 
  email: string; 
  password?: string;
  full_name: string; 
  role: string; 
  branch_id?: string;
  phone?: string;
}) => {
  const { data, error } = await supabase.functions.invoke('create-user', {
    body: userData, // Pasamos todos los userData a la función
  });

  if (error) {
    console.error("Error invoking create-user function:", error);
    throw error;
  }

  if (data.error) { 
    console.error("Error from create-user function:", data.error);
    throw new Error(data.error);
  }
  
  return data.profile || data; 
};

// Update a user by calling the Edge Function
export const updateUser = async (updatePayload: { 
  id: string;
  full_name?: string; 
  role?: string; 
  branch_id?: string;
  phone?: string;
  email?: string; // Nuevo campo
}) => {
  const bodyPayload: any = { 
    userIdToUpdate: updatePayload.id,
    full_name: updatePayload.full_name,
    role: updatePayload.role,
    branch_id: updatePayload.branch_id,
    phone: updatePayload.phone,
    email: updatePayload.email, // Nuevo campo
  };

  // Filtramos undefined para no enviar campos que no se quieren actualizar
  Object.keys(bodyPayload).forEach(key => {
    if (bodyPayload[key] === undefined) {
      delete bodyPayload[key];
    }
  });

  const { data, error } = await supabase.functions.invoke('update-user-profile', {
    body: bodyPayload,
  });

  if (error) {
    console.error("Error invoking update-user-profile function:", error);
    throw error;
  }

  if (data.error) {
    console.error("Error from update-user-profile function:", data.error);
    throw new Error(data.error);
  }
  
  return data;
};

// Set user block status by calling the Edge Function
export const setUserBlockStatus = async (userId: string, isBlocked: boolean) => {
  const bodyPayload = {
    user_id: userId,
    is_blocked: isBlocked,
  };

  const { data, error } = await supabase.functions.invoke('set-status-user', {
    body: bodyPayload,
  });

  if (error) {
    console.error("Error invoking set-status-user function:", error);
    throw error;
  }

  if (data.error) {
    console.error("Error from set-status-user function:", data.error);
    throw new Error(data.error);
  }
  
  // La función devuelve { success: true, user: updatedUser }
  // updatedUser contiene el objeto de usuario de auth.users con el campo blocked_until actualizado.
  return data;
};

// Delete a user
export const deleteUser = async (id: string) => {
  const softDeletePayload = {
    user_id_to_delete: id,
  };
  
  const { data, error } = await supabase.functions.invoke('soft-delete-user', {
    body: softDeletePayload,
  });

  if (error) {
    console.error("Error invoking delete-user function:", error);
    throw error;
  }

  if (data.error) {
    console.error("Error from delete-user function:", data.error);
    throw new Error(data.error);
  }
  
  return data;
};